export default __webpack_public_path__ + "static/media/CarImages.SedonaLarge.cb3abd92.jpg";